module.exports = __webpack_public_path__ + "static/img/demo-1.b3d5ff9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/demo-1.png
// module id = k8KV
// module chunks = 1